import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { SessionActions } from '../session/session-actions';
import { Action } from '@ngrx/store';
import { PushNotificationActions } from './pushnotfication-actions';
import { SessionInfo } from '../../data/authentication-info';
import { map, tap } from 'rxjs/operators';
/**
 * Created by ashok on 14/05/17.
 */

@Injectable()
export class PushNotificationEffects {

    constructor(private actions$: Actions, private pushActions: PushNotificationActions) { }

    // @Effect({ dispatch: false })
    // onPlayerLogin$ = this.actions$.pipe(ofType(SessionActions.PLAYER_LOGGED_IN)).pipe(
    //     map((action: any) => action.payload)).subscribe
    //     ((session: SessionInfo) => {
    //         this.pushActions.registerPlayer(session.playerId);
    //     });




        onPlayerLogin$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SessionActions.PLAYER_LOGGED_IN),
            map((action: any) => action.payload),
            tap((session: SessionInfo) =>this.pushActions.registerPlayer(session.playerId))
        ),
        {
            dispatch: false,
        }
    );


}